import script from "./NewsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsList.vue?vue&type=script&lang=ts&setup=true"

import "./NewsList.vue?vue&type=style&index=0&id=07209aea&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07209aea"]])

export default __exports__